import React, { useState } from 'react';
import { Text, Colors, PrimaryButton } from 'library';
import { Grid } from '@mui/material';
import JobCardList from './JobCardList';
import { PermissionType, useUserContext } from 'UserContext';
import { AddPaymentMethodModal } from 'shared/payments';
import { useWidth } from 'reusableComponents/useWidth';

const UpcomingJobsPage = () => {
    const [paymentSetupModalOpen, setPaymentSetupModalOpen] = useState(false);
    const { user, role, hasPermission, refreshAlreadyLoggedInUser } = useUserContext();
    const width = useWidth();
    const smallScreen = ['xs', 'sm'].includes(width);

    if (role !== 'business_active') return null;

    const openSetupModal = () => {
        setPaymentSetupModalOpen(true);
    };

    const paymentSetupNeeded = !user?.payment_information || user?.payment_information.length <= 0;
    const canManagePayments = hasPermission(PermissionType.ManagePayments);

    return (
        <Grid container direction="column" style={{ flex: 1 }}>
            <Grid container direction="row">
                <Text variant="display">Jobs</Text>
                {paymentSetupNeeded && canManagePayments ? (
                    <>
                        <PrimaryButton
                            buttonStyle={{
                                backgroundColor: Colors.turquoise,
                                width: 'fit-content',
                                marginLeft: 10,
                                marginTop: smallScreen ? 10 : 0,
                            }}
                            onClick={openSetupModal}
                        >
                            Set up TandemPay
                        </PrimaryButton>
                        <AddPaymentMethodModal
                            open={paymentSetupModalOpen}
                            onClose={() => setPaymentSetupModalOpen(false)}
                            onSuccess={() => refreshAlreadyLoggedInUser()}
                        />
                    </>
                ) : null}
            </Grid>
            <Grid style={{ marginTop: 10 }} justifyContent="flex-start">
                <JobCardList />
            </Grid>
        </Grid>
    );
};

export default UpcomingJobsPage;
